/* eslint-disable @typescript-eslint/no-magic-numbers */
export function getVideoIdFromYoutubeString(youtubeString: string): string {
  if (!youtubeString || youtubeString.trim() === '') {
    return '';
  }

  const indexOfVEquals = youtubeString.indexOf('v=');
  if (indexOfVEquals > 0) {
    return youtubeString.substring(indexOfVEquals + 2, indexOfVEquals + 13);
  }

  if (youtubeString.startsWith('https://youtu.be/')) {
    const lastIndex = youtubeString.lastIndexOf('/');
    return youtubeString.substring(lastIndex + 1, lastIndex + 12);
  }

  const indexOfEmbed = youtubeString.indexOf('embed/');
  if (indexOfEmbed > 0) {
    return youtubeString.substring(indexOfEmbed + 6, indexOfEmbed + 17);
  }

  return '';
}
